// @flow
import * as React from 'react';
import Box from 'components/Box';
import interpolateComponents from 'interpolate-components';
import Link, { RouterLink } from 'components/Link';
import Divider from 'components/Divider';
import Form, {
  GeneralError,
  InputField,
  RecaptchaField,
  SubmitButton
} from 'components/Form';
import { FacebookButton, GoogleButton } from 'components/Button';
import { BodySmall } from 'components/Text';
import { trackClicked } from 'utils/analytics';

const EmailSignupForm = ({
  isModal,
  initialValues,
  showLoginModal,
  getLoginUrl,
  getThirdPartyLoginUrl,
  loginOverrideFn,
  onSubmit
}: {
  isModal: boolean,
  initialValues: Object,
  showLoginModal: Function,
  getLoginUrl: Function | Object,
  getThirdPartyLoginUrl: ('facebook' | 'google') => string,
  loginOverrideFn?: Function,
  onSubmit: Function
}) => {
  const LoginLink = ({ email, ...props }: { email?: string }) => {
    if (loginOverrideFn) {
      return (
        <Link
          href="#"
          onClick={e => {
            e.preventDefault();
            trackClicked('Log In');
            loginOverrideFn();
          }}
          {...props}
        />
      );
    }
    if (isModal && showLoginModal) {
      return (
        <Link
          href="#"
          onClick={e => {
            e.preventDefault();
            trackClicked('Log In');
            showLoginModal(email);
          }}
          {...props}
        />
      );
    }
    return (
      <RouterLink
        to={getLoginUrl(email)}
        onClick={() => {
          trackClicked('Log In');
        }}
        {...props}
      />
    );
  };

  const emailErrorWithLogin = (email: string) =>
    interpolateComponents({
      mixedString: getText(
        'Email already in use - Please {{link}}login{{/link}}'
      ),
      components: {
        link: <LoginLink email={email} data-qa-id="email-error-login-link" />
      }
    });

  const mapError = ({ name, value, type, description }) =>
    name === 'email' && type === 'alreadyInUse'
      ? emailErrorWithLogin(typeof value === 'string' ? value : '')
      : description;

  return (
    <Form
      data-qa-id="signup-email-form"
      initialValues={initialValues}
      mapError={mapError}
      onSubmit={onSubmit}
      render={({ values: { email } }) => (
        <>
          <Box display="flex" flexWrap="wrap" mb={4} mt="-6px" mx="-6px">
            <Box m="6px">
              <GoogleButton
                href={getThirdPartyLoginUrl('google')}
                data-qa-id="google-oauth"
              />
            </Box>
            <Box m="6px">
              <FacebookButton
                href={getThirdPartyLoginUrl('facebook')}
                data-qa-id="facebook-oauth"
              />
            </Box>
          </Box>

          <Divider my={24} />

          <GeneralError />

          <InputField
            name="email"
            label={getText('Email')}
            type="email"
            placeholder={getText('casey.smith@example.com')}
          />

          <RecaptchaField />

          <Box mt={[16, null, 40]}>
            <SubmitButton width="100%" size="large">
              {getText('Sign up')}
            </SubmitButton>
          </Box>

          <Box mt={[16, null, 32]}>
            <BodySmall textAlign="center">
              {getText('Already have an account?')}{' '}
              <LoginLink email={email}>{getText('Log in')}</LoginLink>
            </BodySmall>
          </Box>
        </>
      )}
    />
  );
};

export default EmailSignupForm;
